<h3 mat-dialog-title>{{title}}</h3>
<mat-dialog-content>
  <div class="w-100 flex-col justify-center items-stretch">
    <div class="w-100 flex-col justify-center items-stretch">
      <div class="menu-item mt-3">
        <input #fileInput hidden="true" type="file" (click)="fileInput.value=''" (change)="fileInputChange($event)" accept=".json" />
        <a class="w-100" mat-flat-button color="primary" (click)="fileInput.click()">
          <span class="text-bold">Select File</span>
        </a>
      </div>
      <div class="w-100 flex-row flex-wrap justify-center">
        @if (errormessage) {
          <span class="mt-2 warn-color uppercase">{{errormessage}}</span>
        }
        @if (infomessage) {
          <span class="mt-2 primary-color uppercase">{{infomessage}}</span>
        }
      </div>
    </div>
    @if (matchingInputDefinitions.length) {
      <div class="my-3 w-100 flex-col justify-center items-center">
        <mat-select placeholder="Select Input Definition" required [(ngModel)]="selectedInputDefinition">
          @for (match of matchingInputDefinitions; track $index; let i = $index) {
            <mat-option [value]="match.inputDefinition">
              {{match.inputDefinition.name}}: {{matchPercent(match) | percent:'1.0'}} match
            </mat-option>
          }
        </mat-select>
      </div>
    }
    @if (validDefinitionLoaded && matchingInputDefinitions.length==0) {
      <div class="w-100 flex-col justify-center items-center">
        <span class="mt-2 warn-color uppercase">No matching Input Definition found</span>
      </div>
    }
    @if (isConformingWithFileDefinition && matchingConformingFileDefinitions.length) {
      <div class="my-3 w-100 flex-col justify-center items-center">
        <mat-select placeholder="Select Conforming File Definition" required [(ngModel)]="selectedConformingFileDefinition">
          @for (match of matchingConformingFileDefinitions; track $index; let i = $index) {
            <mat-option [value]="match.inputDefinition">
              {{match.inputDefinition.name}}: {{matchPercent(match) | percent:'1.0'}} match
            </mat-option>
          }
        </mat-select>
      </div>
    }
    @if (validDefinitionLoaded && isConformingWithFileDefinition && !matchingConformingFileDefinitions.length) {
      <div class="w-100 flex-col justify-center items-center">
        <span class="mt-2 warn-color uppercase">No matching Conforming File Definition found</span>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions >
  <div class="mt-3 p-2 w-100 flex-row justify-end items-center">
    <a mat-button color="primary" class="dialog-btn mr-5" (click)="onCancelClick()"><span class="text-bold">{{cancelButtonText}}</span></a>
    <a mat-button color="primary" class="dialog-btn" [disabled]='!canImport' (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>


